module.exports = __webpack_public_path__ + "static/img/xt-en.d485f7d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/xt-en.png
// module id = NL6w
// module chunks = 0